import { createAction } from '@reduxjs/toolkit';

export const setLoading = createAction('property/SET_LOADING');
export const setExclusive = createAction('property/SET_EXCLUSIVE', (payload) => ({ payload }));
export const fetchProperty = createAction('property/FETCH_PROPERTY');
export const fetchPropertySuccess = createAction('property/FETCH_PROPERTY_SUCCESS');
export const clearProperty = createAction('property/CLEAR_PROPERTY');
export const setRequestCallbackModalOpen = createAction('property/SET_REQUEST_CALLBACK_MODAL_OPEN');
export const selectItem = createAction('property/SELECT_ITEM', (payload) => ({ payload }));
